import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, TimeoutError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const timeoutValue = request.headers.get('timeout') || 30000; // 30 segundos por defecto
    const timeoutValueNumeric = Number(timeoutValue);

    return next.handle(request).pipe(
      timeout(timeoutValueNumeric),
      catchError(error => {
        if (error instanceof TimeoutError)
          throw new HttpErrorResponse({ error: { message: 'Request Timeout', statusCode: 408 } });

        throw error;
      })
    );
  }
}